var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deferred-job-card",class:{ selected: _vm.selected }},[_c('div',{staticClass:"text-body-4"},[_vm._v(_vm._s(_vm.deferredJob.name))]),(_vm.deferredJob.created_date)?_c('div',{staticClass:"text-body-5"},[_vm._v(" Recommended "+_vm._s(_vm.deferredJob.created_date)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }